import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Small GPT / Claude toggle. GPT stays the default; Claude runs alongside.
export function ModelPicker({ value, onChange, disabled }) {
  const [models, setModels] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/ai/models").then(({ data }) => {
      if (!alive) return;
      setModels(data.models || []);
      if (!value) onChange(data.default || (data.models && data.models[0]?.id));
    }).catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (models.length < 2) return null;
  return (
    <div className="inline-flex items-center gap-0.5 rounded-lg border border-brand-line bg-slate-50 p-0.5" data-testid="model-picker">
      {models.map((m) => (
        <button
          key={m.id}
          type="button"
          data-testid={`model-opt-${m.id}`}
          disabled={disabled}
          onClick={() => onChange(m.id)}
          className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors duration-150 ${
            value === m.id ? "bg-white text-brand-deep shadow-sm" : "text-slate-500 hover:text-slate-700"
          } disabled:opacity-50`}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
